// Form validation for SLA
import { multiselectValidator, plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

// TODO: Validators for sla timings when state stucture is changed

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  slaCondition: { presence: { allowEmpty: false } },
  slaTiming: {
    array: {
      executeIn: {
        presence: {
          allowEmpty: false,
          message: '^This value should be selected'
        }
      }
    }
  },
  ...ruleBuilder('slaCondition.operands')
};
